import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingUrl", "trackingIdentifier", "variant", "size", "children", "postSignupRedirect"];
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import { stringify } from 'hub-http/helpers/params';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { getSignupUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const SignupButton = _ref => {
  let {
      trackingUrl,
      trackingIdentifier,
      variant = 'secondary',
      size,
      children,
      postSignupRedirect
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const location = window.location;
  const params = {
    'hubs_signup-url': trackingUrl || location.href,
    'hubs_signup-cta': trackingIdentifier || null
  };
  if (postSignupRedirect) {
    params.intent = postSignupRedirect;
  }
  const queryString = stringify(params);
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsx(CUIButton, Object.assign({
    onClick: () => trackInteraction('signup button click', {
      identifier: trackingIdentifier
    }),
    as: "a",
    variant: variant,
    size: size,
    href: getSignupUrl(queryString)
  }, rest, {
    children: children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "connect.signupCta"
    })
  }));
};
export default SignupButton;